import {
  Component,
  Input,
  ContentChild,
  TemplateRef,
} from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent {
  show = true;

  @Input() error: string;
  @ContentChild(TemplateRef, {static: false}) template: TemplateRef<any>;
}
